import React from 'react';
import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import { formUi } from '../constants/globalcss';
import { getBaseFormControlStyles } from '../styles/fieldStyles';
import { READABLE_PLACEHOLDER } from './childRowUtils';

export type TableSelectProps = {
  id: string;
  labelText: string;
  options: ReadonlyArray<{ value: string; label: string; tooltip?: string }>;
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
  errorText?: string;
};

export function TableCellTooltipSelect({
  id,
  labelText,
  options,
  value,
  onChange,
  disabled,
  errorText,
}: TableSelectProps) {
  return (
    <FormControl
      disabled={disabled}
      error={Boolean(errorText)}
      fullWidth
      size="small"
      sx={{
        ...getBaseFormControlStyles('100%'),
        display: 'block',
        m: 0,
        maxWidth: '100%',
        '& .MuiOutlinedInput-root': {
          borderRadius: formUi.card.radius,
        },
      }}
    >
      <Select
        displayEmpty
        fullWidth
        id={id}
        inputProps={{ 'aria-label': labelText }}
        onChange={(e) => onChange(String(e.target.value))}
        renderValue={(selected) => {
          if (!selected) {
            return (
              <Typography
                component="span"
                sx={{ color: READABLE_PLACEHOLDER, fontStyle: 'italic' }}
                variant="body2"
              >
                Select…
              </Typography>
            );
          }
          const opt = options.find((o) => o.value === selected);
          return opt?.label ?? String(selected);
        }}
        value={value}
      >
        <MenuItem
          sx={{ color: READABLE_PLACEHOLDER, fontStyle: 'italic' }}
          value=""
        >
          Select…
        </MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            <Tooltip arrow placement="left" title={opt.tooltip}>
              <span style={{ display: 'block', maxWidth: 280, width: '100%' }}>
                {opt.label}
              </span>
            </Tooltip>
          </MenuItem>
        ))}
      </Select>
      {errorText ? (
        <FormHelperText error sx={{ mx: 0 }}>
          {errorText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}
